module.exports = __webpack_public_path__ + "mp.ee67e252aa99f1e76779.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/mp.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/mp.svg
// module chunks = styles